export default __webpack_public_path__ + "static/media/g.8d8aad08.svg";